import React from "react";
import Author from "./Author";
import { authorFull } from "./Author";
import Link from "gatsby-link";
import { Helmet } from "react-helmet";

export default ({ date, title, author, excerpt, socialImage, children }) => {
  const Avatar = authorFull(author);
  return (
    <div className="container-sm">
      <Helmet>
        <title>{title}</title>
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={excerpt} />
        <meta
          name="twitter:image"
          content={
            socialImage
              ? "https://limenius.com" + socialImage
              : "https://limenius.com/social/logo.png"
          }
        />

        <meta property="og:title" content={title} />
        <meta
          property="og:image"
          content={
            socialImage
              ? "https://limenius.com" + socialImage
              : "https://limenius.com/social/logo.png"
          }
        />
        <meta property="og:description" content={excerpt} />
      </Helmet>
      <div className="c-blog--post">
        <div className="u-pull-right">
          <Avatar />
        </div>
        <div className="c-blog--date">{date}</div>
        <div className="c-blog--title h3 o-gradhead">{title}</div>
        <div className="c-blog--back">
          <Link to="/blog/">« Back to blog</Link>
        </div>
        <div className="c-blog--content">{children}</div>
        <div className="c-blog--back">
          <Link to="/blog/">« Back to blog</Link>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/molecules/BlogPost.js